export const AUTH_SESSION_CHANNEL = 'auth-session-change-channel';
export const AUTH_SESSION_MESSAGE_TYPE = 'auth-session-change';

export type AuthSessionMessage = {
  type: typeof AUTH_SESSION_MESSAGE_TYPE;
  userSub: string | null;
  tabId?: string;
};
